export default "__VITE_ASSET__B_WOZ_L2__"